import { useLocation } from 'react-router';
import { routes } from '../../services/routing/routes';

export enum HeaderItem {
  NewQuote = 'newQuote',
  Search = 'search',
  Notes = 'notes',
  ActivityTracking = 'activityTracking',
}

export const useHeaderItems = (): HeaderItem[] | null => {
  const { pathname } = useLocation();

  if (pathname.includes(routes.dashboardHome)) {
    return [];
  }

  if (pathname.includes(routes.conversations)) {
    return [HeaderItem.NewQuote, HeaderItem.Search, HeaderItem.ActivityTracking];
  }

  if (pathname.includes(routes.search)) {
    return [HeaderItem.NewQuote, HeaderItem.Notes, HeaderItem.ActivityTracking];
  }

  if (pathname.includes(routes.newQuote)) {
    return [HeaderItem.NewQuote, HeaderItem.Search, HeaderItem.Notes, HeaderItem.ActivityTracking];
  }

  if (pathname.includes(routes.dashboardQuotes)) {
    return [HeaderItem.NewQuote, HeaderItem.Search, HeaderItem.Notes];
  }

  return null;
};
